import React from "react";
import { ModalHeader as RSModalHeader } from "reactstrap";

const ModalHeader = ({ children }) => {
  return <RSModalHeader>{children}</RSModalHeader>;
};

export default ModalHeader;
